import React, { Component } from "react";

class NewInterest extends Component {

    state = {
        interestValue: '',
    }

    inputChangeHandler = event => {
        this.setState({ interestValue: event.target.value });
    }

    addClickHandler = () => {
        this.props.clicked(this.state.interestValue);
        this.setState({ interestValue: '' });
    }

    render() {
        return (
            <div className="new-interest">
                <input className="new-interest__input" type="text" placeholder="Enter new interest" value={this.state.interestValue} onChange={this.inputChangeHandler} />
                <button className="btn" disabled={this.state.interestValue === ''} onClick={this.addClickHandler}>Add</button>
            </div >
        );
    }
}

export default NewInterest;